import { render } from "./orders-list.vue?vue&type=template&id=6d398162"
import script from "./orders-list.vue?vue&type=script&lang=js"
export * from "./orders-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__